// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"6c6c5b92","74":"c9d67ee1","165":"bfcb0aab","233":"9710e2fd","319":"088fbfbe","453":"d3ea2a8d","492":"6582f466","565":"5f13107f","575":"a42979c7","579":"12f9bcaa","749":"3f755ba2"}[chunkId] + ".chunk.js";
};